import { api } from './index';
export const deliveryAddressesApi = { create(deliveryAddress) { const path = '/api/internal/delivery_addresses'; return api({ method: 'post', url: path, data: { deliveryAddress } }).then(response => response.data); } };
